import { render, staticRenderFns } from "./PanelDetails.vue?vue&type=template&id=2535419e&scoped=true&"
import script from "./PanelDetails.vue?vue&type=script&lang=js&"
export * from "./PanelDetails.vue?vue&type=script&lang=js&"
import style0 from "./PanelDetails.vue?vue&type=style&index=0&id=2535419e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2535419e",
  null
  
)

export default component.exports